import { createContext, useContext, type ReactNode } from 'react'

export interface NestedCodeEditorProps {
  language: string
  value: string
  onChange: (value: string) => void
}

export interface NestedCommentEditorProps {
  compact?: boolean
  bordered?: boolean
  placeholder?: string
  actions?: ReactNode
  focusOnMount: boolean
  onBlur?: () => void
  onChange: (value: string) => void
  testId: string
  value: string
}

type NestedEditorRenderer = (props: NestedCodeEditorProps) => ReactNode

const NestedCodeEditorContext = createContext<NestedEditorRenderer | null>(null)

export function NestedEditorProvider({
  children,
  renderCodeEditor,
}: {
  children: ReactNode
  renderCodeEditor?: NestedEditorRenderer
}) {
  return (
    <NestedCodeEditorContext.Provider value={renderCodeEditor ?? null}>
      {children}
    </NestedCodeEditorContext.Provider>
  )
}

export function useNestedCodeEditor(): NestedEditorRenderer | null {
  return useContext(NestedCodeEditorContext)
}
